/** Immutable comparison snapshot, NOT a factor set or calculation input.
 * C-10b in docs/regulatory/15-verification-log.md is its verification home.
 * Corrections require a new snapshot; never replace a locked database factor with these values.
 */
const row = (region: string, co2: string, ch4: string, n2o: string, rev2: string) =>
  Object.freeze({ region, co2, ch4, n2o, rev2 });

export const EPA_GRID_COMPARISON_2025 = Object.freeze({
  id: "epa-grid-publications-2025-c10b-v1",
  verificationRow: "C-10b",
  publisher: "US EPA",
  retrievedAt: "2026-10-26",
  hubEdition: "GHG Emission Factors Hub 2025, 15 Jan 2025",
  hubSource: "https://www.epa.gov/system/files/documents/2025-01/ghg-emission-factors-hub-2025.pdf#page=3",
  hubGwpSource: "https://www.epa.gov/system/files/documents/2025-01/ghg-emission-factors-hub-2025.pdf#page=1",
  rev2Edition: "eGRID2023 rev2, 12 Jun 2025",
  rev2Source: "https://www.epa.gov/system/files/documents/2025-06/summary_tables_rev2.pdf#page=2",
  // The jurisdiction of the publication this snapshot is about: a fact of the snapshot, so it lives
  // here and not as a literal in the screen that matches against it.
  jurisdiction: "US",
  // The recording the snapshot was first written against. Informational only: ADR-0197 retired it for
  // `us_epa_2025_v2` (the same edition), so a screen matches by edition, publisher and GWP basis and
  // never by this key.
  setKey: "us_epa_2025",
  setEdition: "GHG Emission Factors Hub 2025; eGRID2023 rev2 (12 Jun 2025)",
  gwpSet: "AR5",
  gwp: Object.freeze({ co2: "1", ch4: "28", n2o: "265" }),
  rows: Object.freeze([
    row("CAMX", "436.7", "0.025", "0.003", "430.0"),
    row("NWPP", "631.7", "0.054", "0.008", "635.3"),
    row("ERCT", "738.0", "0.043", "0.006", "736.6"),
    row("AZNM", "740.8", "0.041", "0.006", "706.2"),
  ]),
});
